/**
 * Проверка сессии при загрузке приложения. Пока проверка идёт — загрузчик.
 * Если сервис сессий не ответил (перезапуск gateway, 5xx, обрыв сети), а токен
 * сохранён, это пауза, а не выход: показывается временная недоступность с
 * повтором, и маршруты не уводят на страницу входа. Отказ в сессии (4xx)
 * передаёт решение маршрутам.
 */

import type { ReactNode } from 'react';
import { ApiError, getToken } from '@/api/client';
import { Loader } from '@/components/Loader';
import { WorkspaceState } from '@/components/workspace/WorkspaceState';
import { useSession } from '@/hooks/useAuth';

function sessionServiceUnavailable(error: unknown): boolean {
	if (error instanceof ApiError) return error.status >= 500;
	return error instanceof TypeError;
}

export function SessionGate({ children }: { children: ReactNode }) {
	const { isPending, isError, error, refetch, isFetching } = useSession();

	if (isPending || (isError && isFetching)) {
		return (
			<div className="flex h-screen items-center justify-center">
				<Loader size={32} />
			</div>
		);
	}

	if (isError && getToken() && sessionServiceUnavailable(error)) {
		return (
			<div className="flex h-screen items-center justify-center">
				<WorkspaceState state="unavailable" retry={() => void refetch()} />
			</div>
		);
	}

	return children;
}
